import * as React from "react";
const SvgInfo24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 2.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2ZM.4 11C.4 5.146 5.146.4 11 .4 16.854.4 21.6 5.146 21.6 11c0 5.854-4.746 10.6-10.6 10.6C5.146 21.6.4 16.854.4 11Zm12.1-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-.5 9.5v-6h-2v6h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgInfo24Px;
